module.exports = __webpack_public_path__ + "static/media/varejo-6.3639ce6d.jpg";